export default [{
    path: 'thePriceFor',
    name: 'ThePriceFor',
    meta: {
        title: '价格查询'
    },
    component: () =>
        import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/priceControl/thePriceFor.vue')
  },
  {
    name: 'growTurn',
    path: 'growTurn',
    meta: {
      title: '变扣待办'
    },
    component: () =>
      import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/priceControl/growTurnList.vue')
  },
  {
    name: 'netLineOut',
    path: 'netLineOut',
    meta: {
      title: '外网链接维护'
    },
    component: () =>
      import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/priceControl/netLineOut.vue')
  }
  
]
